export const FAMILY_IMPORT_CSV_HEADERS = [
    "familyName",
    "firstName",
    "lastName",
    "emailAddress",
    "phoneNumber",
    "street",
    "street2",
    "city",
    "state",
    "country",
    "zip",
    "birthday",
];

export const FAMILY_MEMBER_IMPORT_CSV_HEADERS = [
    "firstName",
    "lastName",
    "emailAddress (Required)",
    "userName",
    "password",
    "phoneNumber",
    "birthday",
];

const csvEscape = (value: unknown): string => {
    if (value === null || value === undefined) {
        return "";
    }

    const stringValue = String(value);

    if (
        stringValue.includes(",") ||
        stringValue.includes('"') ||
        stringValue.includes("\n") ||
        stringValue.includes("\r")
    ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
};

export const downloadMemberImportSampleCsv = (
    importType: "family" | "familyMembers"
) => {
    const isFamilyMember = importType === "familyMembers";

    const headers = isFamilyMember
        ? FAMILY_MEMBER_IMPORT_CSV_HEADERS
        : FAMILY_IMPORT_CSV_HEADERS;

    const sampleRow = isFamilyMember
        ? [
            "John",
            "Smith",
            "john.smith@example.com",
            "john.smith",
            "John@12345",
            "+1 555-123-4567",
            "01/15/1985",
        ]
        : [
            "Smith",
            "John",
            "Smith",
            "john.smith@example.com",
            "+1 555-123-4567",
            "123 Main Street",
            "",
            "Houston",
            "Texas",
            "USA",
            "77001",
            "01/15/1985",
        ];

    const csv = [
        headers.join(","),
        sampleRow.map(csvEscape).join(","),
    ].join("\r\n");

    const blob = new Blob(
        [csv],
        { type: "text/csv;charset=utf-8;" }
    );

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = isFamilyMember
        ? "member-import-sample.csv"
        : "family-import-sample.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
};
